<div class="div-arriere-plan-action" (click)="onDismiss(true)"></div>
<div class="div-global-action" (click)="$event.stopPropagation()">
  <div id="center-square">
    <div style="display: flex; justify-content: space-between; flex-direction: column; height: 100%">
      <div class="p-20 text-center" style="border-bottom: solid 1px #E3F2FF;">
        <img class="close-icon" src="assets/close_cross_black.svg" (click)="onDismiss(true)">
        <h3 class="bold header_title dark-blue">Ajouter un utilisateur</h3>
      </div>

      <div class="p-20">
        <p class="dark-blue bold no-margin mb-10">Nom</p>
        <input type="text" class="w-full text-md dark-blue pap-input mb-20" 
          name="lastName" id="lastName" placeholder="Nom" (input)="validateForm()">

        <p class="dark-blue bold no-margin mb-10">Prénom</p>
        <input type="text" class="w-full text-md dark-blue pap-input mb-20" 
          name="firstName" id="firstName" placeholder="Prénom" (input)="validateForm()">

        <p class="dark-blue bold no-margin mb-10">Email</p>
        <input type="email" class="w-full text-md dark-blue pap-input mb-20" 
          name="email" id="email" placeholder="Email" (input)="validateForm()">

        <!-- <div class="flex align-items-center gap-10 mb-20">
          <input type="checkbox" name="sendInvitation" id="sendInvitation">
          <label for="sendInvitation" class="dark-blue bold no-margin">ENVOYER UNE INVITATION EMAIL</label>
        </div> -->

        <p class="dark-blue bold no-margin mb-10">Profil</p>
        <select class="w-full text-md dark-blue pap-input" name="profile" id="profile" (change)="validateForm()">
          <option value="">Sélectionnez un profil</option>
          <option value="0">Ressources Humaines</option>
          <option value="1">Bureau de vote</option>
          <option value="2">Scrutateur</option>
          <option value="3">Chef de projet</option>
        </select>
      </div>

      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;" class="p-20">
        <v8te-active-button [buttonText]="'Annuler'" [primaryColor]="'#FFFFFF'" [textPrimaryColor]="'#2B2D67'"
          [border]="'solid 1px #D9D9D9'" [active]="true" (click)="onDismiss(true)" [height]="50" [minWidth]="190"
          [widthPercent]="100" [bold]="true"></v8te-active-button>

        <v8te-active-button [buttonText]="'Ajouter un utilisateur'" [primaryColor]="'#1990FF'" [textPrimaryColor]="'#FFFFFF'"
          (click)="isFormValid && onAddUser()" [height]="50" [minWidth]="190" [active]="isFormValid" [cursor]="isFormValid ? 'pointer' : 'not-allowed'"
          [widthPercent]="100" [bold]="true" [active]="isFormValid"></v8te-active-button>
      </div>
    </div>
  </div>
</div>